import { requireStates } from "util";
import { ConnectComponent2 } from "util";
import View from "./list/view";
import Presenter from "./list/presenter";

const initialStates = [
  {
    name: "app.registration.optional_group",
    url: "/opcionais",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    },
    data: {
      navigation: {
        priority: 400,
        name: "Opcionais",
        state: "app.registration.optional_group"
      },
      authorization: () => true
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/optional-groups/index.js